import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mcDataPaginate'
})
export class DataPaginatePipe implements PipeTransform {

    transform(array: Array<{}>, args: any): Array<{}> {

        array = array || [];
        if (args === null || typeof args === 'undefined' || args.current === 'undefined'
            || args.limit === 'undefined') {
            return array;
        }

        const current = parseInt(args.current, 10);
        const limit = parseInt(args.limit, 10);

        const start = current * limit;
        let end = start + limit;

        if (end > array.length) {
            end = array.length;
        }

        return array.slice(start, end);

  }

}
